"use client";
import { useEffect, useRef, useState } from "react";
import dictionary from "@/utils/dictionary";
import styles from "./brief.module.scss";

export default function BriefContents({ sections }: { sections: { id: string; title: string }[] }) {
    const [active, setActive] = useState<string>();
    const mobile = useRef<HTMLDetailsElement>(null);
    useEffect(() => {
        const elements = sections.map(({ id }) => document.getElementById(id)).filter((el): el is HTMLElement => !!el);
        let frame = 0;
        const update = () => {
            let current: string | undefined;
            for (const element of elements) {
                if (element.getBoundingClientRect().top <= 220) current = element.id;
            }
            setActive(current);
            frame = 0;
        };
        const onScroll = () => {
            if (!frame) frame = requestAnimationFrame(update);
        };
        update();
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => {
            window.removeEventListener("scroll", onScroll);
            cancelAnimationFrame(frame);
        };
    }, [sections]);
    const links = (
        <ol>
            {sections.map(({ id, title }, index) => (
                <li key={id}>
                    <a
                        href={`#${id}`}
                        aria-current={active === id ? "location" : undefined}
                        onClick={() => {
                            if (mobile.current) mobile.current.open = false;
                        }}
                    >
                        <span aria-hidden="true">{String(index + 1).padStart(2, "0")}</span>
                        <span>{title}</span>
                    </a>
                </li>
            ))}
        </ol>
    );
    return (
        <aside className={styles.contents}>
            <nav className={styles.desktop_contents} aria-label={dictionary.brief.contents}>
                <span className={styles.eyebrow}>{dictionary.brief.contents}</span>
                {links}
                <a className={styles.contents_back} href="#overview">
                    ↑ {dictionary.brief.top}
                </a>
            </nav>
            <details className={styles.mobile_contents} ref={mobile}>
                <summary>
                    {dictionary.brief.contents}
                    <span>
                        {String(sections.length).padStart(2, "0")} <span aria-hidden="true">⌄</span>
                    </span>
                </summary>
                <nav aria-label={dictionary.brief.contents}>{links}</nav>
            </details>
        </aside>
    );
}
